import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { CloudWorkloadSecurityCompanyRecord } from '../types';

export class CloudWorkloadSecurityCustomerViewDataProvider extends BaseWebComponentDataProvider {
  public async createAccount(companyId: string): Promise<{ success: boolean }> {
    const res = await this.dependencies.api.clients.CloudWorkloadSecurity.createAccount(companyId).toPromise();
    return sanitizeObject(res);
  }

  public async getCompany(): Promise<CloudWorkloadSecurityCompanyRecord | undefined> {
    const res = await this.dependencies.api.clients.Company.getCompany({}).toPromise();
    return sanitizeObject(res['data']);
  }
}
